// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__tCJdb","title":"Loading_title__GzN-5"};